import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const TABS = [
  { path: '/monitoring/tasks', label: 'Tasks', icon: 'fa-tasks' },
  { path: '/monitoring/records', label: 'Daily Log', icon: 'fa-clipboard-list' },
  { path: '/monitoring/parameters', label: 'Configure', icon: 'fa-sliders-h' },
  { path: '/monitoring/trends', label: 'Trends', icon: 'fa-chart-line' },
];

const MonitoringNav = () => {
  const location = useLocation();

  return (
    <div className="monitoring-tabs">
      {TABS.map((tab) => (
        <Link
          key={tab.path}
          to={tab.path}
          className={`monitoring-tab ${location.pathname.startsWith(tab.path) ? 'active' : ''}`}
        >
          <i className={`fas ${tab.icon}`}></i>
          {tab.label}
        </Link>
      ))}
    </div>
  );
};

export default MonitoringNav;
